// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backtotop{position:fixed;right:16px;bottom:16px;z-index:1028;display:grid;align-items:center;justify-items:center;place-items:center;width:32px;height:32px;padding:0;background:#3c3c3b;border:0;border-radius:999px;transition:transform .35s}.backtotop svg{width:12px;height:12px;color:#fff;fill:currentcolor}.backtotop.offscreen{transform:translateY(20vh)}", ""]);
// Exports
module.exports = exports;
